import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PrBrandService extends ApiService {

    index(params: any): Observable<any> {
        return super.get('/pr-brands', params);
    }

    store(body: any) {
        return super.post(`/pr-brands`, body);
    }

    edit(prProductId: number) {
        return super.get(`/pr-brands/${prProductId}/edit`);
    }

    update(prProductId: number, body: any) {
        return super.put(`/pr-brands/${prProductId}`, body);
    }

    destroy(prProductId: number) {
        return super.delete(`/pr-brands/${prProductId}`);
    }

    select(params: any = {}) {
        return super.get(`/pr-brands/select`, params);
    }
}
